import styled from "@emotion/styled"
import { FormControl, InputLabel, Typography } from "@mui/material"

export const PhoneInputWrapper = styled(FormControl)`
  width: 100%;
  /* position: relative; */
  .MuiInput-root {
    margin: 0;
    background-color: ${({ theme }) => theme.palette.text.light};
    border-radius: 4px;
  }
  .MuiInputBase-root {
    ::after,
    ::before {
      display: none;
    }
  }
  .MuiInputBase-input {
    padding: 14px;
    letter-spacing: 0.01em;
    color: ${({ theme }) => theme.palette.text.content};
  }
  .PhoneInputCountry {
    margin-right: 0.75rem;
  }
  .PhoneInput {
    border: 1px solid ${({ theme }) => theme.palette.primary.main};
    border-radius: 4px;
    padding: 15.5px 14px;
  }
  &.error {
    .PhoneInput {
      border: 1px solid ${({ theme }) => theme.palette.text.error};
    }
    .MuiFormLabel-root {
      color: ${({ theme }) => theme.palette.text.error};
    }
  }
`

export const Title = styled(Typography)`
  color: #5d5e62;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  margin-bottom: 0.5rem;
`

export const Label = styled(InputLabel)`
  letter-spacing: 0.15px;
  background-color: transparent;
  padding: 0 6px;
  margin-left: -0.25rem;
  top: -2px;
  opacity: 0.6;
  color: #888aa7;
  font-weight: 500;
  &.MuiInputLabel-shrink {
    top: 0;
    opacity: 1;
  }
`

export const ErrorMessage = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.error};
  margin-top: 3px;
  margin-left: 14px;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  text-align: left;
`
